<template lang="pug">
v-container.pa-0.pt-6.pb-6
	v-row.travelbox
		v-col.py-0(cols="12" md="6" v-for="travel in parsed_travels" :key="travel.id")
			a(:href="`/redir?u=${encodeURIComponent(travel.url)}&p=${travel.partner.slug}&i=${travel.id}&t=travel&h=${$redirHash(travel.url)}`" rel="nofollow"  target="_blank" @click="check_travel(travel)")
				v-list-item.pa-0(dense)
					v-list-item-action.ma-0
						v-img(:src="`${travel.partner.image}?width=80`" width="60")
					v-list-item-content.pa-0.mx-3.primary--text {{$tc('travelbox.accommodations_{count}', travel.accommodations)}}
					v-list-item-action.ma-0
						v-btn(x-small color="warning" depressed)
							span(v-if="!travel.checked") {{$t('travelbox.button_cta')}}
							ws-icon(small v-else) check

		ws-dialog(v-model="dialog" :title="destination.name")
			template(#toolbar-title)
				.headline {{destination.name}}
				.subtitle-1 {{$tc('travelbox.{count}_partners', parsed_travels.length)}}

			v-container.travelbox-dialog
				v-row
					v-col(cols="12" md="6")
						a(:href="`/redir?u=${encodeURIComponent(travel.url)}&p=${travel.partner.slug}&i=${travel.id}&t=travel&h=${$redirHash(travel.url)}`" v-for="travel in parsed_travels" rel="nofollow" target="_blank" @click="check_travel(travel)")
							v-list-item.pa-0(dense)
								v-list-item-action.ma-0
									v-img(:src="`${travel.partner.image}?width=80`" width="60")
								v-list-item-content.pa-0.mx-3 {{$tc('travelbox.accommodations_{count}', travel.accommodations)}}
								v-list-item-action.ma-0
									v-btn(x-small color="warning" depressed)
										span(v-if="!travel.checked") {{$t('travelbox.button_cta')}}
										ws-icon(small v-else) check
						v-divider.my-3
						v-progress-linear.d-inline-block.mr-2(v-model="checked_percentage" color="success" height="10" style="width:80px")
						i18n.caption.grey--text(path="travelbox.viewed_{percentage}")
							em(slot="percentage") {{checked_percentage}}%

					v-col(cols="12" md="6")
						.title {{$t('travelbox.popular_weeks')}}
						v-row
							v-col(cols="4")
								.text-center.font-weight-bold {{$dayjs().month(11).format('MMMM')}}
								v-row(dense justify="space-around")
									.item.week.low
									.item.week.medium
									.item.week.medium
									.item.week.veryhigh
							v-col(cols="4")
								.text-center.font-weight-bold {{$dayjs().month(0).format('MMMM')}}
								v-row(dense justify="space-around")
									.item.week.veryhigh
									.item.week.high
									.item.week.medium
									.item.week.medium
							v-col(cols="4")
								.text-center.font-weight-bold {{$dayjs().month(1).format('MMMM')}}
								v-row(dense justify="space-around")
									.item.week.medium
									.item.week.high
									.item.week.high
									.item.week.veryhigh
							v-col(cols="4")
								.text-center.font-weight-bold {{$dayjs().month(2).format('MMMM')}}
								v-row(dense justify="space-around")
									.item.week.veryhigh
									.item.week.high
									.item.week.medium
									.item.week.low
							v-col(cols="4")
								.text-center.font-weight-bold {{$dayjs().month(3).format('MMMM')}}
								v-row(dense justify="space-around")
									.item.week.low
									.item.week.medium
									.item.week.low
									.item.week.low
</template>

<style lang="sass">
.travelbox
	.accommodationsearch
		.v-input, .v-label
			font-size: 13px
		.v-input__slot
			min-height: 30px !important
.travelbox-dialog
	.week
		width: 20px
		height: 20px
		&.low
			background-color: #a2cfec
		&.medium
			background-color: #6d9dbc
		&.high
			background-color: #3b6e90
		&.veryhigh
			background-color: #0d4367
</style>

<script>
import gql from 'graphql-tag';
import MinimumFilter from '@/components/accommodations/minimum-filter.vue';
const { encodeFilters } = require('@dengl/common/utils/filterstrings');

const getAreaTravels = gql`
	query getAreaTravels($slug: String!) {
		destination: area(slug: $slug) {
			id
			name
			slug
			travels: partnerTravels {
				id
				accommodations
				url
				partner {
					id
					image
					name
					slug
					url
				}
			}
		}
	}
`;

const getResortTravels = gql`
	query getResortTravels($slug: String!) {
		destination: resort(slug: $slug) {
			id
			name
			slug
			travels: partnerTravels {
				id
				accommodations
				url
				partner {
					id
					image
					name
					slug
					url
				}
			}
		}
	}
`;

const getCountryTravels = gql`
	query getCountryTravels($slug: String!) {
		destination: country(slug: $slug) {
			id
			name
			slug
			countryCode
			travels: partnerTravels {
				id
				accommodations
				url
				partner {
					id
					image
					name
					slug
					url
				}
			}
		}
	}
`;

const getRegionTravels = gql`
	query getRegionTravels($slug: String!) {
		destination: region(slug: $slug) {
			id
			name
			slug
			travels: partnerTravels {
				id
				accommodations
				url
				partner {
					id
					image
					name
					slug
					url
				}
			}
		}
	}
`;

export default {
	components: { MinimumFilter },
	props: {
		destinationType: {
			type: String,
			required: true,
			validator(value) {
				return ['area', 'resort', 'country', 'region'].includes(value);
			}
		},
		destinationSlug: { type: String, required: true }
	},
	data: () => ({
		checked_travels: [],
		dialog: false,
		destination: { name: '', travels: [] }
	}),
	async fetch() {
		let query = null;
		switch (this.destinationType) {
			case 'area':
				query = getAreaTravels;
				break;
			case 'resort':
				query = getResortTravels;
				break;
			case 'country':
				query = getCountryTravels;
				break;
			case 'region':
				query = getRegionTravels;
				break;
			default:
				console.error('No valid type for travelbox');
		}

		await this.$graphClient
			.query({
				query,
				variables: {
					slug: this.destinationSlug
				}
			})
			.then(({ data }) => {
				data.destination.travels = data.destination.travels.filter(
					travel => travel.partner
				);

				this.destination = data.destination;
			});
	},
	computed: {
		checked_percentage() {
			return Math.round(
				(this.checked_travels.length / this.parsed_travels.length) * 100
			);
		},
		parsed_travels() {
			return this.destination.travels.map(travel => {
				const parsedTravel = this.$lodash.cloneDeep(travel);
				parsedTravel.url = travel.partner.url.replace('{URL}', travel.url);
				parsedTravel.checked = this.checked_travels.includes(travel.id);
				return parsedTravel;
			});
		}
	},
	methods: {
		searchAccommodations(filters) {
			let path = 'accommodations-search';
			const params = {};
			switch (this.destinationType) {
				case 'area':
					path = 'areas-area-accommodationtype';
					params.area = this.destination.slug;
					params.accommodationtype = this.$localeSlug(
						'accommodations',
						this.$i18n.locale
					);
					break;
				case 'resort':
					path = 'resorts-resort-accommodationtype';
					params.resort = this.destination.slug;
					params.accommodationtype = this.$localeSlug(
						'accommodations',
						this.$i18n.locale
					);
					break;
				case 'country':
					filters.countries = [this.destination.countryCode];
					break;
				case 'region':
					filters.regions = [this.destination.slug];
					break;
			}

			this.$router.push(
				this.localePath({
					name: path,
					params,
					hash: `#${encodeFilters(filters, this.$i18n.locale)}`
				})
			);
		},
		check_travel(travel) {
			if (!this.checked_travels.includes(travel.id)) {
				this.checked_travels.push(travel.id);
			}
			this.dialog = true;
		}
	}
};
</script>
